import { render } from "./BackButton.vue?vue&type=template&id=64bd3ca0&scoped=true&ts=true&lang=pug"
import script from "./BackButton.vue?vue&type=script&lang=ts"
export * from "./BackButton.vue?vue&type=script&lang=ts"

import "./BackButton.vue?vue&type=style&index=0&id=64bd3ca0&lang=scss&scoped=true"

import exportComponent from "/tarball/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64bd3ca0"]])

export default __exports__